import {
  formatPercentageValue,
  formatValueWithMiddlewares,
  checkForNA,
  appendPercentage,
  createKpiTileItem,
} from '../../../utils/helper';

export default {
  type: 'KpiTile',
  handler: (data) => {
    const { trueEfficiency, trueEfficiencyPercentageDelta } = data;
    return createKpiTileItem(
      'True Efficiency',
      formatPercentageValue(trueEfficiency),
      trueEfficiencyPercentageDelta
        ? {
            isPositiveValue: trueEfficiencyPercentageDelta >= 0,
            text: formatValueWithMiddlewares(
              Math.abs(trueEfficiencyPercentageDelta),
              [checkForNA, appendPercentage]
            ).toString(),
            sideLabel: '',
            showArrow: trueEfficiencyPercentageDelta !== 0,
          }
        : []
    );
  },
};
